export default __webpack_public_path__ + "static/media/TVS KING GS+ ESPECIAL_4.7a08de13.webp";